export interface IAuthVars {
  appleClientId: string;
  appleBundleId: string;
  appleTeamId: string;
  appleAuthKeyId: string;
  reviewerUserId: string;
}

export const authVars: IAuthVars = {
  appleClientId: 'com.yocoolmate.auth',
  appleBundleId: 'com.yocoolmate.app',
  appleTeamId: '9TCWKML2AJ',
  appleAuthKeyId: 'HN584PJ79H',
  reviewerUserId: '',
};
